import { useEffect, useState } from "react";
import { ReactComponent as OutlineCheckCircle16 } from "assets/svg/outline-check-circle-16.svg";
import {
  today,
  getFreeSlotsForDay,
  getGeneralAvailabilities,
  getBusyTimes,
} from "../Utils";
import getAppointmentTypes from "services/scheduler/querySessionTypesByProId";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import styles from "./AvailabilityTag.module.scss";
import getClasses from "utils/getClasses";

type Props = {
  orchid_pro_cognito_sub: OrchidPro["cognito_sub"];
  highlightToday?: boolean;
  className?: string;
};

const AVAILABILITIES = Object.freeze({
  today: "Available today",
  thisWeek: "Available this week",
  nextWeek: "Available next week",
} as const);

export default function AvailabilityTag({
  orchid_pro_cognito_sub,
  highlightToday,
  className,
}: Props) {
  const [availableCb, setAvailableCb] = useState("");

  useEffect(() => {
    const abortController = new AbortController();

    const options = {
      signal: abortController.signal,
    };
    Promise.all([
      getGeneralAvailabilities(orchid_pro_cognito_sub, options),
      getAppointmentTypes(orchid_pro_cognito_sub, options),
      getBusyTimes(orchid_pro_cognito_sub, options),
    ])
      .then(([schedule, appointment_types, busy_times]) => {
        // TODO: investigate following code can be cleaned up
        // const free_sessions = appointment_types.filter((t) => t.price === 0);
        // const initially_selected_appointment_type =
        //   free_sessions.find((t) => t.label.toLowerCase().includes("intro")) ||
        //   free_sessions[0] ||
        //   appointment_types[0];
        // setState((s) => ({
        //   ...s,
        //   schedule,
        //   appointment_types,
        //   busy_times,
        //   selected_appointment_type: appointment_types.indexOf(
        //     initially_selected_appointment_type,
        //   ),
        // }));
        const shortest_appointment = appointment_types.reduce(
          (accu, current) =>
            accu === null || accu.length_min > current.length_min
              ? current
              : accu,
          null,
        );
        if (shortest_appointment) {
          let day = today();
          let week = 0;
          for (let i = 0; i < 14; ++i) {
            const free_slots = getFreeSlotsForDay(
              schedule,
              busy_times,
              day,
              shortest_appointment,
            ).filter((slot) => (!slot.start ? false : slot.start > new Date()));
            if (free_slots.length > 0) {
              if (+day === +today()) {
                setAvailableCb(AVAILABILITIES.today);
                break;
              }
              if (week === 0) {
                setAvailableCb(AVAILABILITIES.thisWeek);
                break;
              }
              setAvailableCb(AVAILABILITIES.nextWeek);
              break;
            }
            day.setDate(day.getDate() + 1);
            if (day.getDay() === 0) week += 1;
            if (week > 1) break;
          }
        }
      })
      .catch((err: any) => {
        if (err.name !== "AbortError") {
          console.error(err);
        }
      });

    return () => {
      abortController.abort();
    };
  }, [orchid_pro_cognito_sub]);

  const { isPhonePortrait } = usePhonePortraitContext();

  return !availableCb ? null : (
    <div
      className={getClasses(
        styles["availability-tag"],
        isPhonePortrait && styles["availability-tag--phone-view"],
        availableCb === AVAILABILITIES.today &&
          styles[
            `availability-tag--today${!highlightToday ? "" : "-highlighted"}`
          ],
        className,
      )}
    >
      <OutlineCheckCircle16 className={styles["availability-tag__icon"]} />
      {availableCb}
    </div>
  );
}
